import util from '../util'

const controller = 'OperadorOnboarding'

export default Object.assign({}, util.GetCrud(controller, null),{
    AcessoUsuario: function (dto, options) {
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller + "/acesso-usuario", dto)
    },
    AtivarAcesso: function (id) {
        return util.Axios.Post(controller + `/${id}/ativar`, {})
    }
})